











































import { Component, Prop, Vue } from 'vue-property-decorator';

import CloseIcon from '@/components/icons/Close.vue';

import eventBus from '@/utils/eventBus';

import CoinIcon from '@/components/icons/WidgetCoin.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    CloseIcon,
    CoinIcon,
    Typography,
    FilledButton
  }
})
export default class CoinNetworkReturnOnlineModal extends Vue {
  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get tPrefix() {
    return 'modals.billing.returnOnlineOnly';
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  created() {
    segmentIo.modal('Billing Return Online-only');
  }
}
